import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  type?: string;
  jsonLd?: Record<string, any> | Record<string, any>[];
  url?: string;
  image?: string;
}

export default function SEO({ title, description, type = 'website', jsonLd, url = 'https://neurosbox.com', image = 'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?auto=format&fit=crop&q=80&w=1200&h=630' }: SEOProps) {
  const siteName = 'Neuros Box';
  const fullTitle = title.includes(siteName) ? title : `${title} | ${siteName}`;

  // Default SoftwareApplication schema for Agentic Search
  const defaultJsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": siteName,
    "applicationCategory": "HealthAndFitnessApplication",
    "operatingSystem": "Web",
    "description": "Neuros Box is an advanced binaural beats and ambiance generator for focus, relaxation, and sleep.",
    "url": url,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    }
  };

  const schemaData = jsonLd || defaultJsonLd;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@neurosbox" />
      <meta name="twitter:creator" content="@neurosbox" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* JSON-LD for Agentic Search (LLMs) */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
}
